import { FilShowMoreExtended } from './fil-show-more.component';

customElements.define('fil-show-more', FilShowMoreExtended, { unlocked: true });
